module.exports = __webpack_public_path__ + "static/img/celoscope-detail-22.7b6122b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-22.jpg
// module id = aYLF
// module chunks = 52